module.exports = {
  title: 'React Native Swipe Cards Animation (Tinder-like) 👀',
  author: 'Enzo Manuel Mangano',
  date: '2022-12-14',
  slug: 'swipe-cards',
  tags: ['reanimated', 'gesture-handler', 'skia'],
};
